import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import {Button, Grid, Typography} from "@mui/material";
import Modal from "../../../Components/Modal";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import useGlobalContext from "../../../Hooks/useGlobalContext";
import {useSnackbar} from "notistack";
import Cookies from 'js-cookie';
import { Skeleton } from '@mui/material';


interface IPreserveEanProps {
    reloadResourceTable: () => void;
    openModal: boolean;
    setOpenModal: Dispatch<SetStateAction<boolean>>;
}

const PreserveEan: React.FC<IPreserveEanProps> = ({
    reloadResourceTable,
    openModal,
    setOpenModal
}) => {
    const {setLoading, loading} = useGlobalContext();
    const {enqueueSnackbar} = useSnackbar();

    const inputRef = useRef<HTMLInputElement>(null);
    const [file, setFile] = useState<File | null>(null);
    const [enableButton, setEnableButton] = useState<boolean>(false);

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];
        setFile(selectedFile || null);
        setEnableButton(!!selectedFile);
    };

    const save = async () => {
        if (!file) return;
    
        setLoading?.(true);
        const authToken = Cookies.get('authTokenMHP');
    
        const formData = new FormData();
        formData.append("file", file);
    
        try {
            const response = await fetch(process.env.REACT_APP_API_URL + "ean", {
                method: "POST",
                body: formData,
                headers: {
                    'Authorization': `Bearer ${authToken}`
                }
            });
    
            if (!response.ok) {
                throw new Error(`Erro na requisição: ${response.status}`);
            }
    
            const result = await response.json();
    
            if (result?.identifier) {
                enqueueSnackbar(result.message, { variant: 'success' });
                handleCloseModal();
                reloadResourceTable();
            } else {
                enqueueSnackbar(result?.message || 'Erro ao importar arquivo', { variant: 'error' });
            }
    
        } catch (error) {
            console.error("Erro no envio da tabela EAN:", error);
            enqueueSnackbar("Erro inesperado ao importar o arquivo.", { variant: 'error' });
        } finally {
            setLoading?.(false);
        }
    };
    
    const handleCloseModal = () => {
        setOpenModal(false);
        setFile(null);
        setEnableButton(false);
    };

    const reloadDataForm = () => {
        setFile(null);
        setEnableButton(false);
        setTimeout(() => inputRef.current?.focus(), 100);
    };

    useEffect(() => {
        if (openModal) reloadDataForm();
    }, [openModal]);

    return (
        <Modal
            title={'Importar novo Arquivo de tabela EAN'}
            open={openModal && !loading}
            closeModal={handleCloseModal}
            maxWidth='sm'
        >
            <Grid item xs={12} md={12} lg={12} pb={2}>
                <Grid container spacing={0.5}>
                    <Grid item xs={12}>
                        <Button variant="outlined" component="label" fullWidth>
                            Selecione o arquivo de Tabela EAN (.csv)
                            <input
                                type="file"
                                accept=".csv"
                                hidden
                                ref={inputRef}
                                onChange={handleFileChange}
                            />
                        </Button>
                        {file && (
                            <Typography mt={1} variant="body2" color="textSecondary">
                                Arquivo selecionado: {file.name}
                            </Typography>
                        )}
                    </Grid>

                    <Grid item xs={12} display="flex" justifyContent="flex-end">
                        <Button
                            variant="contained"
                            disabled={!enableButton || loading}
                            sx={{ backgroundColor: '#1c2e4a', color: '#FFF' }}
                            onClick={save}
                            >
                            {loading ? (
                                <Skeleton variant="circular" width={20} height={20} sx={{ mr: '5px', bgcolor: '#FFF' }} />
                            ) : (
                                <SaveAsIcon sx={{ marginRight: '5px', marginBottom: '2px' }} />
                            )}
                            Importar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Modal>
    );
};

export default PreserveEan;
